import { useState } from "react";
import { useNavigate } from "react-router-dom";
import PackingListPreview from '../packingList/PackingListPreview'
import logo from "../../Images/LogoT1.png";
export default function EmailDobAuth() {
    const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [dob, setDob] = useState("");
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [error, setError] = useState("");

  // Dummy credentials
  const validEmail = "TandaShakheelAhmad061224";
  const validDob = "1998-10-10";

  const handleLogin = (e) => {
    e.preventDefault();

    if (email === validEmail && dob === validDob) {
      setIsAuthenticated(true);
      navigate("/invoice-desk")
      setError("");
    } else {
      setError("Invalid Email or DOB");
    }
  };

  return (
    <div  className="min-h-[75vh] md:min-h-screen flex items-center justify-center bg-gray-100 p-4">
         <div
              className="absolute inset-0 flex items-center justify-center pointer-events-none"
              style={{
                opacity: 0.2,
                zIndex: 0,
              }}
            >
              <img
                src={logo}
                alt="watermark"
                className="w-[1000px] object-contain"
              />
            </div>
      {!isAuthenticated ? (
        <form
          onSubmit={handleLogin}
          className="w-full max-w-md bg-blue-500/5 backdrop-blur-md border border-blue-200/10 rounded-2xl shadow-xl p-6"
        >
          <h2 className="text-2xl font-bold text-center mb-6">
            Login
          </h2>

          {/* Email */}
          <div className="mb-4">
            <label className="block mb-2 text-sm font-semibold">
              User Name
            </label>

            <input
              type="text"
              placeholder="Enter User Name"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="w-full border border-gray-300 rounded-lg px-4 py-3 outline-none focus:border-green-600"
              required
            />
          </div>

          {/* DOB */}
          <div className="mb-5">
            <label className="block mb-2 text-sm font-semibold">
              Date of Birth
            </label>

            <input
              type="date"
              value={dob}
              onChange={(e) => setDob(e.target.value)}
              className="w-full border border-gray-300 rounded-lg px-4 py-3 outline-none focus:border-green-600"
              required
            />
          </div>

          {/* Error */}
          {error && (
            <p className="text-red-500 text-sm mb-4">
              {error}
            </p>
          )}

          {/* Button */}
          <button
            type="submit"
            className="w-full bg-green-700 hover:bg-green-800 text-white py-3 rounded-lg font-semibold transition-all"
          >
            Authenticate
          </button>
        </form>
      ) : (
        <div className="bg-white p-8 rounded-2xl shadow-xl text-center">
          <h2 className="text-3xl font-bold text-green-700 mb-3">
            Authenticated
          </h2>

          <p className="text-gray-600">
            Welcome to the dashboard
          </p>
        </div>
      )}
    </div>
  );
}